import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { amountToLong } from '../../utils/amountToLong';
import { paymentModalClosed } from '../../utils/bi/events/applePay';
import { type BiLogger } from '../../components/Provider/BiLogger/BiLogger';

type CancelHandlerParams = {
  biLogger: BiLogger;
  biData: {
    paymentAmount: string;
    currencyCode: string;
  };
};

/**
 * Handles cancel event
 */
export const cancelHandler =
  ({ biLogger, biData }: CancelHandlerParams) =>
  async () => {
    biLogger.report(paymentModalClosed, {
      amount: amountToLong(biData.paymentAmount),
      currency: biData.currencyCode,
      checkoutType: 'express',
      paymentProvider: PaymentProvider.WixPayUS,
      paymentmethod: PaymentMethod.ApplePay,
      isPartner: undefined as any, // TODO[bi]
      externalOrderId: undefined as any, // TODO[bi]
      cartId: undefined as any, // TODO[bi]
      orderSnapshotId: undefined as any, // TODO[bi]
      transactionId: undefined as any, // TODO[bi]
      pageType: undefined as any, // TODO[bi]
    });

    return Promise.resolve();
  };
